var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"steps"},_vm._l((_vm.steps),function(item){return _c('li',{key:item,class:item <= _vm.step ? 'active' :''},[_vm._v(" "+_vm._s(_vm.step === item ? '校准中' : (item > _vm.step ? '待校准' : '已完成'))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }